<template>
  <!-- 员工提成详情 -->
  <el-drawer
    title="提成列表"
    :visible.sync="visible"
    @close="close"
    size="1500px"
    :close-on-press-escape="false"
    :wrapperClosable="false"
    id="comDrawer"
    :modal-append-to-body="false"
  >
    <div class="page">

      <div class="tableBox" style="height: 100%">
        <el-table :data="tableData">
          <el-table-column prop="orderNo" label="订单号" width="150px">
          </el-table-column>
          <el-table-column prop="performanceSubType" label="业绩类型">
            <template slot-scope="scope">
              <div v-show="scope.row.performanceSubType == 1">商品销售</div>
              <div v-show="scope.row.performanceSubType == 2">美容业绩</div>
              <div v-show="scope.row.performanceSubType == 3">洗澡业绩</div>
              <div v-show="scope.row.performanceSubType == 4">医疗病例</div>
              <div v-show="scope.row.performanceSubType == 5">疫苗驱虫核销</div>
              <div v-show="scope.row.performanceSubType == 6">医疗服务核销</div>
              <div v-show="scope.row.performanceSubType == 7">疫苗驱虫销售</div>
              <div v-show="scope.row.performanceSubType == 8">医疗服务销售</div>
              <div v-show="scope.row.performanceSubType == 9">洗美卡销售</div>
              <div v-show="scope.row.performanceSubType == 10">寄养业绩</div>
              <div v-show="scope.row.performanceSubType == 11">跟诊业绩</div>
              <div v-show="scope.row.performanceSubType == 12">夜诊</div>
              <div v-show="scope.row.performanceSubType == 13">夜诊护理</div>
              <div v-show="scope.row.performanceSubType == 14">DR补助</div>
              <div v-show="scope.row.performanceSubType == 15">
                自有宠物洗澡
              </div>
              <div v-show="scope.row.performanceSubType == 16">
                百天医疗补助
              </div>
              <div v-show="scope.row.performanceSubType == 17">接送补助</div>
              <div v-show="scope.row.performanceSubType == 18">活体业绩</div>
              <div v-show="scope.row.performanceSubType == 19">活体奖金</div>
            </template>
          </el-table-column>
          <!-- performanceSubType -->
          <el-table-column prop="orderItemId" label="商品名" width="300px">
          </el-table-column>

          <el-table-column
            prop="orderPayTime"
            label="订单支付时间"
            width="120px"
          >
            <template slot-scope="scope">
              {{ scope.row.orderPayTime.split(" ")[0] }}
            </template>
          </el-table-column>
          <el-table-column
            prop="performanceMoney"
            label="业绩金额"
            width="80px"
          >
          </el-table-column>
          <el-table-column
            prop="commissionMoney"
            label="提成计算金额"
            width="120px"
          >
          </el-table-column>
          <el-table-column
            prop="differencePrice"
            label="提成差价金额"
            width="120px"
          >
          </el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              <div v-show="scope.row.state == 1">生效</div>
              <div v-show="scope.row.state == 2">未生效</div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" width="220px">
            <template slot-scope="scope">
              <div>{{ scope.row.remark ? scope.row.remark : "" }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            v-if="$buttonAuthority('shuju-moneypk-edit')"
            width="300px"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handelStartEndClick(scope.row, 1)"
                >修改提成金额</el-button
              >
              <el-button @click="del(scope.row)" type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagePosi">
          <page
            :total="page.total"
            :pageSize="page.pageSize"
            :page="page.page"
            @change="changePage"
            style="padding-bottom: 10px"
          ></page>
        </div>
      </div>

      <!-- 修改提成金额 -->
      <el-dialog
        title="修改提成金额"
        :modal-append-to-body="false"
        :visible.sync="dialogVisible"
        width="20%"
        :before-close="handleClose"
        append-to-body>
        <el-form>
          <el-form-item label="业绩金额">
            <el-input
              type="number"
              v-model="commissionMoney"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="提成金额">
            <el-input
              type="number"
              v-model="performanceMoney"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="提成差价金额">
            <el-input
              type="number"
              v-model="differencePrice"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="text" v-model="remark" clearable></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="RegisterVisible">确 定</el-button>
        </span>
      </el-dialog>

  
    </div>
  </el-drawer>
</template>

<script>
import moment from "moment";
import page from "../../components/page.vue";
// import drawerCandolistCat from "./upload.vue"
export default {
  components: {
    page,
    // drawerCandolistCat,
  },
  data() {
    return {
     
      dialogVisible: false, //修改金额
      visible: true,
      commissionMoney: 0,
      performanceMoney: 0,
      differencePrice: 0,
      confirmId: "",
      takeTime: "",
      orderNo: "",
      remark: "",
      search: {
        keyword: "",
        state: 0, //0全部 1生效；2未生效
        performanceOrderType: 0, //	订单类型 0全部 1 订单消费 2 订单退款 3 疫苗驱虫 4 医疗服务
      },
      state: 0,
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
      
      cardList: [
        { value: "60210f916e6d952a3929f0ed", label: "洗澡卡" },
        { value: "60210f916e6d952a3929f0ef", label: "SPA卡" },
        { value: "60210f916e6d952a3929f0ee", label: "美容卡" },
      ],
      dialogAddWashCard_state: false,
      options: [
        {
          value: 1,
          label: "商品销售",
        },
        {
          value: 2,
          label: "美容业绩",
        },
        {
          value: 3,
          label: "洗澡业绩",
        },
        {
          value: 4,
          label: "医疗病例",
        },
        {
          value: 5,
          label: "疫苗驱虫核销",
        },
        {
          value: 6,
          label: "医疗服务核销",
        },
        {
          value: 7,
          label: "疫苗驱虫销售",
        },
        {
          value: 8,
          label: "医疗服务销售",
        },
        {
          value: 9,
          label: "洗美卡销售",
        },
        {
          value: 10,
          label: "寄养业绩",
        },
        {
          value: 11,
          label: "跟诊业绩",
        },
        {
          value: 12,
          label: "夜诊",
        },
        {
          value: 13,
          label: "夜诊护理",
        },
        {
          value: 14,
          label: "DR补助",
        },
        {
          value: 15,
          label: "自有宠物洗澡",
        },
        {
          value: 16,
          label: "百天医疗补助",
        },
        {
          value: 17,
          label: "接送补助",
        },
        {
          value: 18,
          label: "活体业绩",
        },
        {
          value: 19,
          label: "活体奖金",
        },
      ],
    };
  },
  props: {
    type: {
      default: () => {},
    },
    time: {
      type: String,
      default: () => "",
    },
    staffId: {
      default: "",
    },
  },
  created() {},
  mounted() {
    console.log(this.type, this.time, this.staffId);
    // this.type = this.$route.query.type
    this.getTableData();
  },
  methods: {
    close() {
      this.$emit("submit", {
        type: "close",
      });
    },
   

    // 获取订单列表
    getTableData() {
      let time = moment(this.$public.Timer(this.time)).format("YYYY-MM-DD");
      let begin_time = moment(time).startOf("month").format("YYYY-MM-DD");
      let end_time = moment(time).endOf("month").format("YYYY-MM-DD");
      console.log(begin_time, end_time, "end_time");
      let params = {
        staffId: this.staffId,
        keyword: this.search.keyword,
        theMonth: this.time,
        toMonth: this.type.montName,
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
      };
      let loading = this.$loading();
      //process.env.VUE_APP_zichan process.env.VUE_APP_zichan +
      this.$http
        .post(
          process.env.VUE_APP_zichan +
            "/api/Performance/GetStaffCommissionDifferenceList",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.page.total = res.data.count;
          }
        });
    },

    // 时间
    changeDatetime(val) {},
    handleClose(done) {
      this.$emit("close");
    },

    // 修改金额
    handelStartEndClick(row) {
      console.log(row, "row");
      this.orderNo = row.orderNo;
      this.remark = row.remark;
      this.confirmId = row.id;
      this.differencePrice = row.differencePrice;
      this.commissionMoney = row.commissionMoney;
      this.performanceMoney = row.performanceMoney;
      this.dialogVisible = true;
    },
    RegisterVisible() {
      let params = {
        orderNo: this.orderNo,
        commissionMoney: Number(this.commissionMoney),
        performanceMoney: Number(this.performanceMoney),
        differencePrice: Number(this.differencePrice),
        remark: this.remark,
      };
      this.$http
        .post(
          process.env.VUE_APP_zichan +
            "/api/Performance/UpdateOrderDifferencePrice",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            // console.log(res);
            this.$message({
              type: "success",
              message: "成功",
            });
            this.dialogVisible = false;
            this.commissionMoney = "";
            this.performanceMoney = "";
            this.commissionMoney = "";
          }
          this.getTableData();
        });
    },
    // 删除
    del(row) {
      this.$confirm("此操作将删除此数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            ids: row.id,
          };
          this.$http
            .get(
              process.env.VUE_APP_zichan +
                "/api/Performance/DeleteStaffCommission",
              params
            )
            .then((res) => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "已删除",
                });
              }
              this.getTableData();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
    // 重置
    reset() {
      this.search.keyword = "";
      this.search.state = "";
      this.page.page = 1;
      this.getTableData();
    },
    handleComClick() {
      this.page.page = 1;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 16px 16px 65px 16px;
  box-sizing: border-box;
  position: relative;
  overflow-x: hidden; // 隐藏x轴滚动条
  overflow-y: auto;
  height: calc(
    100vh - 120px
  ); // 用屏幕可视高度减去 头部与底部的高度，就是中间元素的高度

  .titleUp {
    display: flex;
  }

  .screenLine {
    display: flex;

    .screenLineR {
      flex: 1;
      text-align: right;
    }
  }

  .tableBox {
    padding: 16px;
    border-radius: 8px;
    background-color: #fff;
    box-sizing: border-box;
    margin-top: 16px;
    height: calc(100% - 86px);
  }

  // .pagePosi {
  //     position: absolute;
  //     bottom: 0;
  //     left: 16px;
  //     right: 16px;
  //     text-align: right;
  //     background-color: #fff;
  //     padding: 0 10px;
  //     border-radius: 8px 8px 0 0;
  // }
}
</style>
